import { render, staticRenderFns } from "./BeforeProceed.vue?vue&type=template&id=868c7164&scoped=true"
import script from "./BeforeProceed.vue?vue&type=script&lang=js"
export * from "./BeforeProceed.vue?vue&type=script&lang=js"
import style0 from "./BeforeProceed.vue?vue&type=style&index=0&id=868c7164&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "868c7164",
  null
  
)

export default component.exports